import { initGoogleMapsLoader } from "./google_maps_loader.js"
import $ from "jquery"


document.addEventListener("turbolinks:load", function() {
  var markers = document.getElementsByClassName("marker-tag")
  var not_visible_markers = document.getElementsByClassName("not-visible-marker-tag")
  if($("#categorySideMap").length > 0){
    display_map_with_markers("categorySideMap", markers, not_visible_markers);
  }
  if($("#mapOnTopStorageShowPage").length > 0){
    display_map_with_markers("mapOnTopStorageShowPage", markers, not_visible_markers)
  }
})

var center;
var marker;
var marker_position;
function display_map_with_markers(map_container_id, markers, not_visible_markers, zoom = 17){

  if(markers.length + not_visible_markers.length == 0){
    display_empty_map_from_germany(map_container_id)
  } else {
    let map_container = document.getElementById(map_container_id)
    initGoogleMapsLoader().then(() => {
      center = markers[0] || not_visible_markers[0]
      var map = new google.maps.Map(map_container, {
        zoom: zoom,
        center: parsePositionFromMarkerTag(center),
        disableDefaultUI: true,
        language: I18n.currentLocale(),
      });

      if(map_container.dataset.markers && map_container.dataset.markers.length > 0){
        let icons = JSON.parse(map_container.dataset.markers)
        const legend = document.createElement("div");

        legend.className = "maps-legend border-0 shadow";

        icons.forEach(function(icon) {
          const div = document.createElement("div");
          div.className = "maps-legend-item";
          div.innerHTML = '<img src="' + icon.icon_url + '"> ' + icon.name;
          legend.appendChild(div);
        });

        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);
      }

      var lat_lng_bounds = new google.maps.LatLngBounds();
      for (var i = 0; i < markers.length; i++) {
        marker = add_marker(google, map, markers[i]);
        lat_lng_bounds.extend(marker.getPosition())
      }
      for (var i = 0; i < not_visible_markers.length; i++) {
        marker_position = parsePositionFromMarkerTag(not_visible_markers[i])
        lat_lng_bounds.extend(marker_position)
      }
      map.fitBounds(lat_lng_bounds)
      var zoomChangeBoundsListener = google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
        if (this.getZoom() > 14){
          this.setZoom(14);
        }
      });
      setTimeout(function(){google.maps.event.removeListener(zoomChangeBoundsListener)}, 2000);
    });
  }
}

function display_empty_map_from_germany(map_container_id){
  initGoogleMapsLoader().then(() => {
    var map = new google.maps.Map(document.getElementById(map_container_id), {
      zoom: 6,
      center: {lat: 50.84, lng: 10.21},
      language: I18n.currentLocale(),
    })
  });
}

function parsePositionFromMarkerTag(marker_tag){
  var lng = parseFloat(marker_tag.getElementsByClassName("lng")[0].innerText)
  var lat = parseFloat(marker_tag.getElementsByClassName("lat")[0].innerText)
  return {lng: lng, lat: lat}
}

function add_marker(google, map, marker_tag){
  var title = marker_tag.getElementsByClassName("title")[0].innerText
  var position = parsePositionFromMarkerTag(marker_tag)
  var iconUrl = parseIconUrlFromMarkerTag(marker_tag)
  const icon = {
    url: iconUrl,
    scaledSize: new google.maps.Size(27,48), // scaled size
    origin: new google.maps.Point(0,0), // origin
    anchor: new google.maps.Point(27/2,48) // anchor
};
  var url = parseUrlFromMarkerTag(marker_tag)
  marker = new google.maps.Marker({
    position: position,
    map: map,
    title: title,
    icon: icon,
    url: url
  });
  google.maps.event.addListener(marker, 'click', function() {
      window.location.href = this.url;
  });
  return marker;
}

function parseUrlFromMarkerTag(marker_tag) {
  return marker_tag.getElementsByClassName("url")[0].innerText.trim()
}
function parseIconUrlFromMarkerTag(marker_tag) {
  return marker_tag.getElementsByClassName("icon_url")[0].innerText.trim()
}
